import type { ComponentProps, ComponentType, FC, ReactNode } from 'react';

import styled from '@mint-lib/styled';
import { type NavigateOptions } from '@mint/routing';
import DrawerM, { DrawerProps as DrawerPropsM } from '@mui/material/Drawer';

import Icon from '../Icon/Icon.jsx';
import SidebarButton from './SidebarButton.jsx';

export interface SidebarIconInterface {
  id?: string;
  title: string;
  icon: ComponentType<ComponentProps<'svg'>>;
  path?: NavigateOptions['to'];
  /**
   * Deprecated: use `path` instead
   */
  paths?: NavigateOptions['to'][];
  exact?: boolean;
  onClick?: (e: React.MouseEvent<any>) => void;
}

export interface SideBarProps extends DrawerPropsM {
  /**
   * Side from which the drawer will appear.
   * @default 'left'
   */
  anchor?: 'left' | 'right';
  /**
   * logo
   */
  logo?: ReactNode;
  /**
   * array of Icons
   */
  topIcons: SidebarIconInterface[];
}

const SideBar: FC<SideBarProps> = ({
  anchor = 'left',
  logo,
  topIcons,
  ...props
}) => {
  return (
    <StyledDrawer variant="permanent" anchor={anchor} {...props}>
      <TopIconsWrapper>
        <WrapLogo>{logo}</WrapLogo>
        {topIcons.map(({ path, paths, title, icon, onClick }) => (
          <SidebarButton
            key={title}
            path={path}
            paths={paths}
            title={title}
            icon={icon}
            onClick={onClick}
          />
        ))}
      </TopIconsWrapper>
      <Icon
        component="MintLogoSidebar"
        sx={{
          width: '1.5rem',
          height: '11rem',
          position: 'absolute',
          bottom: '7.5rem',
          right: '0',
        }}
      />
    </StyledDrawer>
  );
};

export default SideBar;

const StyledDrawer = styled(DrawerM, {
  shouldForwardProp: (prop) => prop !== 'onBackdropClick',
})(({ theme }) => ({
  color: theme.palette.text.disabled,
  '.MuiDrawer-paper': {
    backgroundColor: `${theme.palette.greyscale.grey70}`,
    display: 'flex',
    justifyContent: 'space-between',
    border: 'none',
    borderRight: `1px solid ${theme.palette.ui.tertiary}`,
  },
}));

const WrapLogo = styled('div')({
  margin: '0.25rem 0.25rem 1.25rem 0.25rem',
  width: '2.5rem',
  height: '2.5rem',
});

const TopIconsWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '8px',
});
